import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject } from 'aurelia-framework';
import { ContextMenu } from './context-menu';
@autoinject()
export class ActionBar {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) message: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) contextMenu: ContextMenu;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) showListNavigator: boolean = false;
     @bindable({ defaultBindingMode: bindingMode.oneWay }) showBackButton: boolean = true;

    constructor() {
    }

    goBack() {
        window.history.back();
    }
    attached() {
    }
}